export default __webpack_public_path__ + "static/media/mail.f76a54ee.svg";